import { allWidgetNames } from "$root/widgets-architecture/layout/WidgetsMapper";
import z from "zod";

export const storedWidgetEntrySchema = z.object({
	i: z.enum(allWidgetNames as [(typeof allWidgetNames)[number], ...(typeof allWidgetNames)[number][]]),
	span: z.union([z.literal(1), z.literal(2), z.literal(3)]),
	hidden: z.boolean().optional(),
});

export const storedGridSchema = z.array(storedWidgetEntrySchema);

/** Shape persisted in user storage — minSpan/maxSpan are always derived from the default grid, never stored. */
export type StoredWidgetEntry = z.infer<typeof storedWidgetEntrySchema>;

/** Runtime shape — minSpan/maxSpan are hydrated from the default grid config, not stored. */
export type WidgetEntry = StoredWidgetEntry & {
	minSpan: 1 | 2 | 3;
	maxSpan: 1 | 2 | 3;
};

export type PageWidgetsLayout = {
	widgets: WidgetEntry[];
};
